import { FormRegistration } from '@/components/form-registration';
import { StepLabel } from '@/components/form-registration';
import { HeaderMenu } from '@/components/header-menu';
import { routesApp } from '@/constans/routes';
import { useAuth } from '@/store/useAuth';
import { Spiner } from '@/ui-kit';
import { useState } from 'react';
import { generatePath, useParams } from 'react-router-dom';

const generateBackUrlSteps = (stepNumer?: string) => {
    const step = Number(stepNumer);
    if (!Number.isNaN(step) && step <= 4 && step > 1) {
        return generatePath(routesApp.registration, { stepNumer: String(step - 1) });
    }
    return generatePath(routesApp.home);
};

export const Registration = () => {
    const [isLoadingOnce, setIsLoadingOnce] = useState(true);
    const userData = useAuth((state) => state.getUser());
    const { stepNumer } = useParams();
    return userData ? (
        <>
            <HeaderMenu>
                <StepLabel stepNumber={stepNumer as string} />
            </HeaderMenu>
            <FormRegistration
                step={stepNumer}
                isLoadingOncePage={isLoadingOnce}
                onChangeIsLoadingPage={setIsLoadingOnce}
            />
        </>
    ) : (
        <Spiner />
    );
};
